import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "message-bubble",
  "use": "message-bubble-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"message-bubble\">\n  <path d=\"M15.0625,3 L4.9375,3 C3.32175,3 2,4.32175 2,5.9375 L2,17 L5,14 L15.0625,14 C16.678,14 18,12.678 18,11.0625 L18,5.9375 C18,4.32175 16.678,3 15.0625,3 Z M16,11.0625 C16,11.57075 15.57075,12 15.0625,12 L4,12 L4,5.9375 C4,5.42925 4.42925,5 4.9375,5 L15.0625,5 C15.57075,5 16,5.42925 16,5.9375 L16,11.0625 Z M6,7 L14,7 L14,8 L6,8 L6,7 Z M6,9 L12,9 L12,10 L6,10 L6,9 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol